import { render, staticRenderFns } from "./GlobalInsightsStandalone.vue?vue&type=template&id=b8ebe99a&scoped=true"
import script from "./GlobalInsightsStandalone.vue?vue&type=script&lang=js"
export * from "./GlobalInsightsStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ebe99a",
  null
  
)

export default component.exports